'use client';

import addCartPic from '@/assets/icons/cart-landpage-black.png';
import CartSVG from '@/assets/icons/cart.svg';
import { useStores } from '@/models';
import { sendClickTrack, sendKeyActionTrack } from '@/tracks/Activity';
import pageSDK from '@/utils/goToPage';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import style from './cartLayer.module.scss';
interface cartLayerProps {
  shouldDisplayCart: boolean;
  eventTrackingId?: string;
}

const CartLayer: React.FC<cartLayerProps> = observer(({ shouldDisplayCart, eventTrackingId }) => {
  const { cartNumStore } = useStores();
  const { displayCartNum, isCartNumValid } = cartNumStore;
  let pageId = '';

  // ---------------- 埋点配置 ---------------- //
  const getDefaultTrackingId = () => {
    let pathname = '';
    if (typeof window === 'undefined') {
      const { headers: nextHeaders } = require('next/headers');
      pathname = nextHeaders().get('pathname') === null ? '/' : nextHeaders().get('pathname');
    } else {
      pathname = new URL(window.location.href).pathname;
    }

    const cmsIndex = pathname.indexOf('cms/');
    return cmsIndex > -1 ? pathname.substring(cmsIndex + 4) : '';
  };
  if (eventTrackingId) {
    pageId = eventTrackingId;
  } else {
    const defaultTracking = getDefaultTrackingId();
    if (defaultTracking === 'flash-sales') {
      pageId = 'Activity_FlashSales';
    } else if (defaultTracking === 'welcome-discount') {
      pageId = 'Activity_Discount';
    } else {
      pageId = `cms_${defaultTracking}`;
    }
  }

  useEffect(() => {
    sendKeyActionTrack.cartLayer_Expo(pageId, { cartSkuNumber: displayCartNum });
    cartNumStore.fetchCartNum();
  }, []);

  // 点击购物车浮层事件
  const gotoCart = () => {
    // ----------------- 如果有埋点id，就上报【购物车浮层点击】事件】---------------------- //

    sendClickTrack.CartLayer(pageId, { cartSkuNumber: displayCartNum });
    setTimeout(() => {
      pageSDK.goToPage({
        jumpType: 'fun',
        jumpValue: {
          obj: {
            urlJumpTerminalList: [
              {
                terminal: 5,
                jumpCode: 'cart',
              },
            ],
          },
        },
      });
    }, 500);
  };
  return (
    shouldDisplayCart &&
    isCartNumValid && (
      <div>
        <div className={style.cart} onClick={() => gotoCart()}>
          <div className={style.cartImg}>
            <CartSVG />
          </div>

          {/* <Image src={addCartPic} alt='add cart' width={40} height={40} /> */}
          <div className={style.cartNum}>{displayCartNum}</div>
        </div>
      </div>
    )
  );
});

export default CartLayer;
